import { action, computed, observable, reaction, runInAction } from 'mobx'

export default class StoreView {
  rootStore = null

  #reactions = []

  @observable accessor isInitializing = false
  @observable accessor isInitialized = false
  @observable accessor user = null

  constructor(rootStore) {
    this.rootStore = rootStore
    this.rootStore.registerDeconstructor(this.#_deconstructor)

    this.#reactions.push(reaction(() => this.user, this.#updateSeo))
  }

  #_deconstructor = () => {
    this.#reactions.forEach(x => x())
    this.#reactions = []
  }

  init = async () => {
    if (this.isInitializing) return

    runInAction(() => {
      this.isInitializing = true
    })

    await this.#loadData()

    runInAction(() => {
      this.isInitializing = false
      this.isInitialized = true
    })
  }

  @action
  reset = () => {
    this.user = null
    this.posts.reset()
    this.users.reset()
    this.seo.reset()
    this.isInitializing = false
    this.isInitialized = false
  }

  get router() {
    return this.rootStore.routerStore
  }

  get posts() {
    return this.rootStore.repositories.postsRepository
  }

  get seo() {
    return this.rootStore.seoStore
  }

  get users() {
    return this.rootStore.repositories.usersRepository
  }

  @computed
  get exists() {
    return Boolean(this.user)
  }

  #loadData = async () => {
    if (!this.isInitialized && !this.isInitializing) return

    const user = await this.users.getFromServer(this.router.params.handle)
    runInAction(() => {
      this.user = user
    })

    if (!this.exists) return

    return this.posts.initStore(this.user.address)
  }

  #updateSeo = () => {
    if (!this.exists) return

    this.seo.update({
      description: this.user.about,
      image: this.user.cover,
      keywords: [this.user.nickname],
      title: this.user.nickname,
    })
  }
}
